<template>
  <div>
    <v-row>
      <v-col cols="6">
        <h1 class="headline font-weight-light mb-3">
          <router-link class="link-a" :to="'/Inventory/Transfer'">
            VIEW TRANSFER</router-link
          >
          / PRINT
        </h1>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6" class="text-right">
        <v-btn rounded small @click="print()">
          <v-icon class="mr-1" dark small>mdi-printer</v-icon>
          Print</v-btn
        >
      </v-col>
    </v-row>

    <div id="printDivTransfer">
      <!-- {{ data_print }} -->
      <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
      <div style="margin: 30px !important;">
        <v-row class="mt-4">
          <v-col cols="3">
            <img
              src="../../assets/bardode/acacia2.png"
              style="width: 60% !important;"
            />
          </v-col>
          <v-col cols="6" class="text-center">
            <b>เอกสารการ transfer อะไหล่</b>
          </v-col>
          <v-col cols="3">
            <b>วันที่ : {{ data_print_transfer.created_date }}</b>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="2" class="text-right "><b>ส่งจาก :</b></v-col>
          <v-col cols="4">{{ data_print_transfer.from_branch }}</v-col>
          <v-col cols="2" style="font-size:20px;" class="text-right"
            ><b>ส่งถึง :</b></v-col
          >
          <v-col cols="4" style="font-size:20px;">{{
            data_print_transfer.branch_name
          }}</v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
          <v-col cols="4">{{ data_print_transfer.from_addr }}</v-col>
          <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
          <v-col cols="4">{{ data_print_transfer.branch_addr_en }}</v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col cols="12">
            <table border="1" width="100%">
              <thead>
                <tr
                  class="text-center"
                  style="background-color: rgb(221, 221, 221);"
                >
                  <th>No</th>
                  <th>Part No</th>
                  <th>Description</th>
                  <th>Single Part</th>
                  <th>SN</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(n, index) in data_print_transfer.transfer_detail"
                  :key="index"
                >
                  <td class="text-center">{{ index + 1 }}.</td>
                  <td class="text-center">
                    {{ n.part_name }}
                  </td>
                  <td class="text-center">
                    {{ n.part_description }}
                  </td>
                  <td class="text-center">{{ n.singlepart }}</td>
                  <td class="text-center">{{ n.serial }}</td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="6" class="text-right">
            <b>ผู้ส่ง (Inventory)</b>
            ___________________________________
          </v-col>
          <v-col cols="6" class="text-right">
            <b>ผู้รับ (Engineer)</b>
            ___________________________________
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="6" class="text-right">
            <b>วันที่ส่ง</b> ___________________________________
          </v-col>
          <v-col cols="6" class="text-right">
            <b>วันที่รับ</b> ___________________________________
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

import { mapState, mapMutations } from "vuex";
import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

export default {
  mounted() {
    this.get_data();
  },
  ...mapMutations(["mutateMiniSidebar"]),
  methods: {
    async get_data() {
      await axios
        .get(
          `${process.env.VUE_APP_ROOT_API}/api/transfer_print/` +
            this.$route.params.transfer_id
        )
        .then((response) => {
          // console.log(response)
          this.data_print_transfer = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    print() {
      const localOptions = {
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        ],
      };

      this.$htmlToPaper("printDivTransfer", localOptions, () => {});
    },
  },
  data() {
    return {
      data_print_transfer: [],
    };
  },
};
</script>
